import React from 'react';
import { Stack, Button, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

type Situacao = 'Novo' | 'Em andamento' | 'Finalizado' | 'Em coleta (Rascunho)' | 'Sincronizado' | 'Enviado ao Estado';

interface Props {
  situacao: Situacao;
  activeCollection: any;
  onContinuar: (uuid?: string) => void;
  onNovoFormulario: () => void;
  onValidarEEnviar: () => void;
  onVisualizar: () => void;
}

const ActionButtons: React.FC<Props> = ({ situacao, activeCollection, onContinuar, onNovoFormulario, onValidarEEnviar, onVisualizar }) => (
  <Stack direction="column" spacing={2} width="100%">
    {situacao === 'Em andamento' && activeCollection ? (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        startIcon={<EditIcon />}
        onClick={() => onContinuar(activeCollection?.uuid)}
      >
        Continuar Preenchimento
      </Button>
    ) : (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        startIcon={<AddIcon />}
        onClick={onNovoFormulario}
      >
        Iniciar Novo Formulário
      </Button>
    )}

    {situacao === 'Sincronizado' && (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={onValidarEEnviar}
        sx={{ marginTop: 2 }}
      >
        Validar e Enviar ao Estado
      </Button>
    )}

    <Divider />

    <Stack direction="row" spacing={2}>
      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        startIcon={<VisibilityIcon />}
        onClick={onVisualizar}
        disabled={situacao === 'Novo' || !activeCollection?.uuid}
      >
        Visualizar
      </Button>
    </Stack>
  </Stack>
);

export default ActionButtons;
